"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _lodash = _interopRequireDefault(require("lodash.get"));
var _useContextSelector2 = require("use-context-selector");
var _utils = require("../../../../../utils");
var _ui = require("../../../../ui");
var _transactionInfo = require("../transaction-info");
var _BalanceName = require("../BalanceName");
var _TwoFactorForm = require("./TwoFactorForm");
var _Context = require("../page/Context");
var _state = require("../../../../../state");
var _balance = require("../providers/balance");
var _createWithdraw = require("../providers/create-withdraw");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ModalBody = (0, _styledComponents.default)(_ui.ModalBody)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 20px 30px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0 10px 40px;\n  "]))));
var TotalAmount = (0, _styledComponents.default)(_transactionInfo.TransactionInfoTotalAmount)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var StyledAlert = (0, _styledComponents.default)(_ui.Alert)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-top: 28px;\n  margin-bottom: 20px;\n"])));
var Button = (0, _styledComponents.default)(_ui.Button)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n"])));
var ConfirmModal = function ConfirmModal(_ref) {
  var children = _ref.children,
    alertText = _ref.alertText,
    onSubmit = _ref.onSubmit,
    fee = _ref.fee,
    convertedTickerFee = _ref.convertedTickerFee,
    blockchain = _ref.blockchain,
    total = _ref.total,
    convertedTickerTotal = _ref.convertedTickerTotal,
    balanceAfterTransaction = _ref.balanceAfterTransaction,
    convertedBalanceAfterTransaction = _ref.convertedBalanceAfterTransaction;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon', 'libAuth']),
    t = _useTranslation.t;
  var _useContext = (0, _react.useContext)(_balance.BalanceContext),
    balanceName = _useContext.balanceName;
  var _useContextSelector = (0, _useContextSelector2.useContextSelector)(_Context.Context, function (_ref2) {
      var closeModal = _ref2.closeModal,
        toggleModal = _ref2.toggleModal,
        modalOpen = _ref2.modalOpen,
        ticker = _ref2.ticker,
        to = _ref2.to,
        convertedTicker = _ref2.convertedTicker,
        amount = _ref2.amount,
        convertedTickerAmount = _ref2.convertedTickerAmount,
        isEnoughBalance = _ref2.isEnoughBalance;
      return {
        closeModal: closeModal,
        toggleModal: toggleModal,
        modalOpen: modalOpen,
        ticker: ticker,
        to: to,
        convertedTicker: convertedTicker,
        amount: amount,
        convertedTickerAmount: convertedTickerAmount,
        isEnoughBalance: isEnoughBalance
      };
    }),
    closeModal = _useContextSelector.closeModal,
    toggleModal = _useContextSelector.toggleModal,
    modalOpen = _useContextSelector.modalOpen,
    ticker = _useContextSelector.ticker,
    to = _useContextSelector.to,
    convertedTicker = _useContextSelector.convertedTicker,
    amount = _useContextSelector.amount,
    convertedTickerAmount = _useContextSelector.convertedTickerAmount,
    isEnoughBalance = _useContextSelector.isEnoughBalance;
  var _useContext2 = (0, _react.useContext)(_createWithdraw.CreateWithdrawContext),
    useCreateWithdraw = _useContext2.useCreateWithdraw;
  var _useCreateWithdraw = useCreateWithdraw(),
    withdrawState = _useCreateWithdraw.withdrawState,
    resetWithdraw = _useCreateWithdraw.resetWithdraw;
  var _useContext3 = (0, _react.useContext)(_balance.BalanceContext),
    useBalances = _useContext3.useBalances;
  var _useBalances = useBalances(),
    recalculateBalances = _useBalances.recalculateBalances;
  (0, _react.useEffect)(function () {
    if (withdrawState.done) {
      closeModal();
      resetWithdraw();
      recalculateBalances({
        value: total,
        convertedValue: convertedTickerTotal,
        ticker: ticker,
        increase: false
      });
    }
  }, [withdrawState.done]);

  // reset withdraw state (feeLessThanRequired) to not fetch new fee on ticker or amount change
  (0, _react.useEffect)(function () {
    if (withdrawState.feeLessThanRequired) resetWithdraw();
  }, [ticker, amount, withdrawState.feeLessThanRequired]);
  var btnText = t(!isEnoughBalance ? 'notEnoughBalance' : withdrawState.feeLessThanRequired ? 'rateChanged' : 'confirm&send');
  var submitLoading = withdrawState.loading;
  var submitDisabled = !isEnoughBalance;
  var _useUser = (0, _state.useUser)(),
    user = _useUser.user;
  var withdraw2faEnabled = (0, _lodash.default)(user, 'credentials.withdraw2faEnabled', false);
  return /*#__PURE__*/_react.default.createElement(_ui.Modal, {
    isOpen: modalOpen,
    toggle: toggleModal
  }, /*#__PURE__*/_react.default.createElement(_ui.ModalHeader, {
    toggle: toggleModal
  }, t('sendingConfirmation')), /*#__PURE__*/_react.default.createElement(ModalBody, null, /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('from')
  }, /*#__PURE__*/_react.default.createElement(_BalanceName.BalanceName, {
    ticker: ticker,
    value: balanceName
  })), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('to')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate"
  }, to)), blockchain && /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoItem, {
    title: t('network')
  }, /*#__PURE__*/_react.default.createElement("span", null, t('blockchains.' + blockchain), " ", t('network'))), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('amount'),
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: amount,
    convertedTickerAmount: convertedTickerAmount
  }), fee && /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: t('serviceFee'),
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: fee,
    convertedTickerAmount: convertedTickerFee,
    className: "mb-0"
  }), /*#__PURE__*/_react.default.createElement(TotalAmount, {
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: total,
    convertedAmount: convertedTickerTotal
  }), withdraw2faEnabled ? /*#__PURE__*/_react.default.createElement(_TwoFactorForm.TwoFactorForm, {
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "secondary",
    loading: submitLoading,
    disabled: submitDisabled,
    type: "submit",
    wide: true
  }, btnText)) : /*#__PURE__*/_react.default.createElement(Button, {
    color: "secondary",
    loading: submitLoading,
    disabled: submitDisabled,
    onClick: function onClick() {
      return onSubmit({});
    },
    type: "submit",
    wide: true
  }, btnText), /*#__PURE__*/_react.default.createElement(_transactionInfo.TransactionInfoAmountItem, {
    title: "".concat(balanceName !== null && balanceName !== void 0 ? balanceName : t('personal'), " ").concat(t('libCommon:balance').toLowerCase(), " ").concat(t('after'), ":"),
    ticker: ticker,
    convertedTicker: convertedTicker,
    amount: balanceAfterTransaction,
    convertedTickerAmount: convertedBalanceAfterTransaction
  }), children, /*#__PURE__*/_react.default.createElement(StyledAlert, {
    component: _ui.ExtraSmall
  }, alertText)));
};
exports.ConfirmModal = ConfirmModal;